"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidImageUrlWarning = imageDimensions => {
    return imageDimensions === undefined;
};
exports.retinaWarning = (imageDimensions, containerDimensions) => {
    if (imageDimensions === undefined)
        return false;
    const containerHasPxHeight = containerDimensions.heightFormat === 'px' && !!containerDimensions.heightValue;
    const containerHasPxWidth = containerDimensions.widthFormat === 'px' && !!containerDimensions.widthValue;
    return ((containerHasPxHeight && imageDimensions.height < containerDimensions.heightValue * 2) ||
        (containerHasPxWidth && imageDimensions.width < containerDimensions.widthValue * 2));
};
//# sourceMappingURL=calculate-warnings.js.map